// application/useCapacitacionCatalogos.js  (catálogos del formulario; localidades dependen del municipio)
import { catalogosRepository } from '../../shared/infrastructure/catalogos.repository';
import { useCatalogo } from '../../shared/application/useCatalogo';

export const useCapacitacionCatalogos = ({ idMunicipio, idCooperativa, catalogos = catalogosRepository } = {}) => {
  const actividades = useCatalogo(() => catalogos.actividades(), [catalogos]);
  const municipios = useCatalogo(() => catalogos.municipios(), [catalogos]);
  const localidades = useCatalogo(() => catalogos.localidades(idMunicipio), [catalogos, idMunicipio]);
  const ciclos = useCatalogo(() => catalogos.ciclos(idCooperativa), [catalogos, idCooperativa]);

  const loading = [actividades, municipios, localidades, ciclos].some(c => c.status === 'loading');
  return {
    actividades: actividades.data,
    municipios: municipios.data,
    localidades: localidades.data,
    ciclos: ciclos.data,
    loading,
    localidadesLoading: localidades.status === 'loading',
    ciclosReady: ciclos.status === 'success' || ciclos.status === 'error',
  };
};

export default useCapacitacionCatalogos;
